import { Role } from '../auth/auth.context'
import i18n from '../i18n'

export const roleToText = (role: Role) => {
  switch (role) {
    case 'ADMIN':
      return i18n.t('roles.admin')
    case 'SUPERADMIN':
      return i18n.t('roles.superadmin')
    case 'EMPLOYEE':
      return i18n.t('roles.employee')

    default:
      return i18n.t('roles.unknown')
  }
}

export const subscriptionStatusToText = (status: string | null | undefined): string => {
  if (!status) return i18n.t('common.dash')
  
  const statusLower = status.toLowerCase()
  const statusKey = `subscription.status.${statusLower}`
  
  if (i18n.exists(statusKey)) {
    return i18n.t(statusKey)
  }
  
  return status
}

export const employeeFunctionToText = (func: string | null | undefined): string => {
  if (!func) return i18n.t('common.dash')
  
  const functionMap: Record<string, string> = {
    'IT': i18n.t('employee.functions.it'),
    'HR': i18n.t('employee.functions.hr'),
    'Lager': i18n.t('employee.functions.warehouse'),
    'Putzkraft': i18n.t('employee.functions.cleaning'),
    'Pflege': i18n.t('employee.functions.care'),
  }
  
  return functionMap[func] || func
}
